<div class="flex flex-col h-full relative">
  <div #map class="w-full h-full flex-1"></div>
</div>
